import { render, staticRenderFns } from "./FormattedAddress.vue?vue&type=template&id=fea85028&"
import script from "./FormattedAddress.vue?vue&type=script&lang=js&"
export * from "./FormattedAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports